module.exports = __webpack_public_path__ + "media/images/responsive/page_common/recommend/recommend_faq-84548d964c1b3a69ebb8b6fb3a7ea39b.jpg";